export const requestResponseValidate = (filesCode) => {

    const errors = {}

    for (let key in filesCode) {
        if (!filesCode[key]) {
            errors.title = "لطفا عنوان را وارد کنید"
        } else {
            delete errors.title
        }
    }

    return errors;
}